export class StorageService {
	private readonly _storage: Storage;

	constructor(local: boolean = false) {
		if (local) {
			this._storage = localStorage;
		} else {
			this._storage = sessionStorage;
		}
	}

	public get<T>(key: string): T {
		const value: string = this._storage.getItem(key) || null;
		try {
			const objValue: T = JSON.parse(value);
			return objValue;
		} catch {
			// eslint-disable-next-line @typescript-eslint/no-explicit-any
			return value as any;
		}
	}

	public set<T>(key: string, item: T): void {
		this._storage.setItem(key, JSON.stringify(item));
	}

	public hasKey(key: string): boolean {
		// eslint-disable-next-line @typescript-eslint/no-explicit-any
		const value: any = this._storage.getItem(key);
		return value !== undefined && value !== null;
	}

	public getKeys(): string[] {
		return Object.keys(this._storage);
	}

	public remove(key: string, exact: boolean = true): void {
		if (exact) {
			this._storage.removeItem(key);
		} else {
			const keys: string[] = [];
			for (let i = 0; i < this._storage.length; i++) {
				keys.push(this._storage.key(i));
			}
			keys.forEach((k) => {
				if (k.includes(key)) {
					this.remove(k);
				}
			});
		}
	}

	public clear(): void {
		this._storage.clear();
	}
}
